import { Injectable } from '@angular/core';
import { RequestService } from '@app/core/request/request.service';
import { Observable } from 'rxjs';
import { FileUpload } from '@app/core/interfaces/bewijsstukken';

@Injectable()
export class DocumentsService {

    constructor(
        private request: RequestService,
    ) {}

    public getDocuments$(dossier_volgnummer: number): Observable<any> {
        const payload = {
            dossier: {
                dossier_volgnummer: dossier_volgnummer
            }
        };

        return this.request.post('schade-correspondentie/opvragen/bewijsstukken', payload);
    }

    public submitDocuments$(dossier_volgnummer: number, upload_enveloppe_volgnummer: number): Observable<any> {
        const payload = {
            dossier: {
                dossier_volgnummer: dossier_volgnummer
            },
            upload: {
                upload_enveloppe_volgnummer: upload_enveloppe_volgnummer
            }
        };

        return this.request.post('schade-correspondentie/indienen/bewijsstuk', payload);
    }

    public uploadBewijsstuk$(dossier_volgnummer: number, upload: FileUpload): Observable<any> {
        const payload = {
            dossier: {
                dossier_volgnummer: dossier_volgnummer,
            },
            upload: upload
        };

        return this.request.post('schade-correspondentie/uploaden/bewijsstuk', payload);
    }

    public removeUploadBewijsstuk$(
        dossier_volgnummer: number,
        upload_enveloppe_volgnummer: number,
        upload_enveloppe_item_volgnummer: number
        ): Observable<any> {
        const payload = {
            dossier: {
                dossier_volgnummer: dossier_volgnummer,
            },
            upload: {
                upload_enveloppe_volgnummer: upload_enveloppe_volgnummer,
                upload_enveloppe_item_volgnummer: upload_enveloppe_item_volgnummer
            }
        };

        return this.request.post('schade-correspondentie/verwijderen/bewijsstuk', payload);
    }
}
